import { jwtDecode } from 'jwt-decode'
import type { StytchJWTPayload } from '@/types/stytch'
import { getOrgSlugFromStytchPayload } from '@/utilities/shared/stytchSession'

/**
 * Extract organization slug from a Stytch session JWT
 *
 * @param sessionJWT The Stytch session JWT token string
 * @param fallbackToId If true, falls back to internal_organization_id when slug is missing (default: false)
 * @returns The organization slug in lowercase, or null if not found
 */
export function getOrgSlugFromJWT(
  sessionJWT: string | StytchJWTPayload,
  fallbackToId: boolean = false,
): string | null {
  try {
    const decoded =
      typeof sessionJWT === 'string' ? jwtDecode<StytchJWTPayload>(sessionJWT) : sessionJWT
    return getOrgSlugFromStytchPayload(decoded, fallbackToId)
  } catch {
    return null
  }
}
